import classNames from 'classnames';
import React, { ReactNode } from 'react';

import InfoIcon from '@mui/icons-material/InfoOutlined';
import { makeStyles } from '@mui/styles';

import { Colors } from 'styleguide-v2/src/styles/Colors';
import { Fonts } from 'styleguide-v2/src/styles/Variables';

import { Tooltip } from '../Tooltip';

type Props = {
  className?: string;
  label: ReactNode;
  labelTooltip?: ReactNode;
  value?: ReactNode;
  subvalue?: ReactNode;
  type?: 'primary' | 'secondary';
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexFlow: 'column',
    gap: '0.25rem',
  },
  labelPrimary: {
    color: Colors.iconGray,
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: `calc(${Fonts.fontSize} * 0.625)`,
    letterSpacing: '1px',
    marginBottom: '0.25rem',
  },
  labelSecondary: {
    color: Colors.textBlack,
    fontWeight: 500,
    fontSize: `calc(${Fonts.fontSize} * 0.75)`,
    marginBottom: '0.25rem',
  },
  value: {
    fontSize: `calc(${Fonts.fontSize} * 0.875)`,
    fontWeight: 500,
    textWrap: 'wrap',
  },
  subvalue: {
    color: Colors.iconGray,
    fontSize: `calc(${Fonts.fontSize} * 0.75)`,
    fontWeight: 500,
  },
});

export const Data = ({
  className,
  label,
  labelTooltip,
  value,
  subvalue,
  type = 'primary',
}: Props) => {
  const styles = useStyles();

  return (
    <div className={classNames(className, styles.container)}>
      {label && (
        <span
          className={classNames(
            type === 'primary' && styles.labelPrimary,
            type === 'secondary' && styles.labelSecondary,
          )}
        >
          <div className="flex gap">
            {label}
            {labelTooltip && (
              <Tooltip text={labelTooltip}>
                <InfoIcon color="info" fontSize="small" />
              </Tooltip>
            )}
          </div>
        </span>
      )}
      {value && <span className={styles.value}>{value}</span>}
      {subvalue && <span className={styles.subvalue}>{subvalue}</span>}
    </div>
  );
};

export default Data;
